import React from 'react';

import ContentShell from '@/app/layout-shells/content-shell/ContentShell';
import EditorShell from '@/app/layout-shells/editor-shell/EditorShell';
import EmbeddedFooterShell from '@/app/layout-shells/embedded-shell/parts/footer-shell/FooterShell';
import EmbeddedToolbarShell from '@/app/layout-shells/embedded-shell/parts/toolbar-shell/ToolbarShell';
import ProgressIndicator from '@/shared/components/progress-indicator/ProgressIndicator';

export default function AppShell() {
  return (
    <ContentShell>
      <ProgressIndicator delay={1000} />
      <EmbeddedToolbarShell />
      <EditorShell />
      <EmbeddedFooterShell />
    </ContentShell>
  );
}
